<template>
  <div class="user">
    <div class="cardBox">
      <div class="left">
        <div class="infoBox">
          <div class="avatar">
            <img
              :src="userData.headImg || require('@/assets/images/user.png')"
            />
          </div>

          <div class="info">
            <div class="name">
              {{ userData.nickName }}
              <!-- <i class="el-icon-arrow-right"></i> -->
            </div>
            <div class="iphone">
              {{ userData.iphone }}
            </div>
            <div class="vip" v-if="userData.memberlevel > 1">
              <img
                :src="
                  $store.state.onlineBasePath +
                  'group1/M00/12/22/L2pUHWR-7XqAKWxpAAAJfMcinIk476.png'
                "
                alt=""
              />
              <span class="bold">VIP</span>
              <span>{{ userData.expirationDate }}</span>
              <span class="color">到期</span>
              <!-- <div class="btn">续费</div> -->
            </div>
            <div class="equity" v-else>
              <span>开通VIP获得更多权益</span>

              <div class="btn">立即前往</div>
            </div>
          </div>

          <div class="wallet_box" @click="isName = 'withdraw'">
            <div class="withdrawal_img">收益/提现</div>

            <div class="cashWithdrawAmount">
              ¥{{
                userData.cashWithdrawAmount
                  ? userData.cashWithdrawAmount == 0
                    ? '0.00'
                    : userData.cashWithdrawAmount
                  : '0.00'
              }}
            </div>
          </div>
        </div>

        <div class="insert">
          <span v-if="userData.signature" style="line-height: 1.4"
            >{{ userData.signature }}
          </span>
          <span v-else>
            完善个性签名更容易获取大家的关注，点击添加
            <i class="el-icon-arrow-right"></i>
          </span>
        </div>

        <div class="top_btn_big">
          <div class="top_btn">
            <div @click="isName = 'authentication'">申请认证</div>
            <div @click="isName = 'editData'">编辑资料</div>
          </div>
          <div class="top_btn">
            <!-- <div @click="goUploadWorks()">
							+原创发布
						</div> -->
          </div>
        </div>

        <!-- <div class="banner">
          <img :src="$store.state.wqurl + 'InviteFriends_banner.png'" alt="" />
        </div> -->

        <div class="vipBox">
          <div class="vip_cont">
            <img :src="$store.state.wqurl + 'user_character.png'" alt="" />
            <span>{{ userData.characterUse || 0 }} 字符</span>
            <!-- <div class="text">
							充值
						</div> -->
          </div>

          <div class="vip_cont">
            <img :src="$store.state.wqurl + 'user_draw.png'" alt="" />
            <span>{{ userData.aiImgNum || 0 }} 次</span>
            <!-- <div class="text">
							充值
						</div> -->
          </div>

          <div class="vip_cont">
            <img :src="$store.state.wqurl + 'user_download.png'" alt="" />
            <span>{{ userData.downloadNum || 0 }} 次</span>
          </div>
        </div>

        <div class="inter_box">
          <div class="inter_item">
            <span>{{ userData.worksNum || 0 }}</span
            >内容
          </div>
          <div class="inter_item">
            <span>{{ userData.praiseNum || 0 }}</span
            >获赞
          </div>
          <div
            class="inter_item"
            style="cursor: pointer"
            @click="isName = 'followList'"
          >
            <span style="color: #326afb">{{ userData.attention || 0 }}</span
            >关注
          </div>
          <div class="inter_item">
            <span>{{ userData.fans || 0 }}</span
            >粉丝
          </div>
        </div>

        <div class="nav_box">
          <div
            class="nav_item"
            @click="onNavList(v)"
            v-for="(v, i) in navList"
            :key="i"
          >
            <img :src="$store.state.wqurl + v.img" alt="" />

            <span>{{ v.name }}</span>
          </div>
        </div>

        <div class="logout">
          <el-button type="primary" round @click="loginOut">退出登录</el-button>
        </div>
      </div>

      <div class="right">
        <component :userData="userData" :is="isName"></component>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import works from './components/works'
import myOrder from './components/myOrder'
import Management from './components/Management'
import followList from './components/followList'
import authentication from './components/authentication'
import editData from './components/editData'

import withdraw from './components/withdraw'
import Cookies from 'js-cookie'
export default {
  name: 'user',
  //import引入的组件需要注入到对象中才能使用
  components: {
    works,
    myOrder,
    authentication,
    followList,
    withdraw,
    editData,
    Management,
  },
  props: {
    userData: {},
  },
  data() {
    //这里存放数据
    return {
      isName: 'myOrder',
      navList: [
        {
          img: 'user_page/practicingWriter.png',
          name: '我的任务',
          fun: this.onNotice,
          isName: 'myQuest',
        },
        {
          img: 'user_practice.png',
          name: '我的执业',
          fun: this.onNotice,
          isName: 'Practice',
        },
        // {
        //   img: "user_page/businessCardLibrary.png",
        //   name: "我的名片",
        // },
        // {
        //   img: "user_page/systemMessages.png",
        //   name: "消息",
        // },
        {
          img: 'user_order.png',
          name: '我的订单',
          fun: () => {
            this.isName = 'myOrder'
          },
        },
        {
          img: 'fuwu_icon.png',
          name: '专业服务管理',
          fun: () => {
            this.isName = 'Management'
          },
        },
        // {
        //   img: "textDetails_collect2.png",
        //   name: "收藏中心",
        // },
        // {
        //   img: "user_history.png",
        //   name: "浏览历史",
        // },
        // {
        //   img: "textDetails_download.png",
        //   name: "下载中心",
        // },
        // {
        //   img: "user_myLive.png",
        //   name: "我的直播",
        // },
        // {
        //   img: "user_liveHistory.png",
        //   name: "观看历史",
        // },
      ],
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //退出登录
    loginOut() {
      this.$confirm('此操作将退出当前登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.isLogin = false
          this.userInfo = false //Cookies.remove("auth_token"); //清除token
          Cookies.set('auth_token', '', {
            expires: -1,
            path: '/',
            domain: '.writemall.com',
          })

          localStorage.removeItem('auth_token') //清除用户信息 // localStorage.clear();
          this.$store.commit('SET_USER_INFO', {
            userInfo: null,
          })
          this.$store.commit('CLEAR_REAL_NAME') // this.$router.push("/infoCompileIndex"); // this.$bus.$emit("changeNavIndex", "文库");

          window.location.reload(true)
          this.isUser_info = JSON.parse(window.localStorage.getItem('vuex'))
            ?.user_info
            ? JSON.parse(window.localStorage.getItem('vuex'))?.user_info
            : ''
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消退出',
          })
        })
    },
    onNavList(v) {
      v.fun(v.isName)
    },

    onNotice(val) {
      this.$bus.$emit('goApplyDetails', val)
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
.user {
  margin-bottom: 40px;
  .cardBox {
    display: flex;
    gap: 20px;
    margin: 20px auto 0;
    height: 700px;
    width: 1130px;
    .left {
      background: url('https://payment-writemall-com.oss-cn-shenzhen.aliyuncs.com/miniapps/wqzk/user_back_img.png')
        no-repeat;
      background-size: 100%;
      width: 375px;
      border-radius: 10px;
      height: 100%;
      background-color: #fff;
      position: relative;

      .infoBox {
        display: flex;
        align-items: center;
        gap: 10px;
        position: relative;
        padding: 15px;
        box-sizing: border-box;
        .avatar {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background-color: #fff;
          overflow: hidden;
          img {
            width: 100%;
          }
        }
        .info {
          display: flex;
          flex-direction: column;
          justify-content: center;
          gap: 5px;
          .name {
            cursor: pointer;
            font-size: 16px;
            font-weight: bold;
            display: flex;
            gap: 5px;
          }
          .iphone {
            font-size: 12px;
            font-weight: 500;
            color: #333;
          }
          .vip {
            display: flex;
            align-items: center;
            font-size: 11px;
            gap: 4px;

            img {
              width: 15px;
            }

            .bold {
              color: #f27800;
              font-weight: bold;
            }

            .color {
              color: #f27800;
            }

            .btn {
              cursor: pointer;
              height: 20px;
              line-height: 20px;
              padding: 0 5px;
              background: #ffe5ae;
              margin-left: 3px;
              border-radius: 3px;
              color: #f27800;
            }
          }

          .equity {
            font-size: 11px;
            display: flex;
            align-items: center;
            color: #7394bf;

            .btn {
              cursor: pointer;
              height: 20px;
              line-height: 20px;
              padding: 0 5px;
              background: #ffe5ae;
              margin-left: 3px;
              border-radius: 3px;
              color: #f27800;
            }
          }
        }
        .wallet_box {
          position: absolute;
          right: 10px;
          font-size: 12px;
          color: #f27800;
          cursor: pointer;
          .withdrawal_img {
            width: 88px;
            height: 25px;
            background: url('https://payment-writemall-com.oss-cn-shenzhen.aliyuncs.com/miniapps/wqzk/withdrawal_img.png')
              no-repeat;
            background-size: 100% 100%;
            text-align: right;
            box-sizing: border-box;
            padding-right: 8px;
            line-height: 25px;
          }
          .cashWithdrawAmount {
            margin-top: 8px;
            text-align: center;
          }
        }
      }
      .insert {
        display: flex;
        font-size: 12px;
        gap: 10px;
        cursor: pointer;
        padding: 0 15px;
        box-sizing: border-box;
      }
      .top_btn_big {
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 10px 15px 0;
        .top_btn {
          display: flex;
          align-items: center;
          gap: 10px;
          div {
            cursor: pointer;
            height: 30px;
            padding: 0 10px;
            line-height: 30px;
            font-size: 14px;
            text-align: center;
            border-radius: 5px;

            background: rgba(0, 0, 0, 0.3);
            color: #fff;
          }
        }
      }
      .banner {
        padding: 15px;
        box-sizing: border-box;
        img {
          cursor: pointer;
          width: 100%;
          height: 55px;
        }
      }
      .vipBox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 15px;
        width: calc(100% - 30px);
        margin: 20px auto;
        height: 45px;
        box-sizing: border-box;
        font-size: 12px;
        color: #ffd8ae;
        background: url('https://fafs.antiplagiarize.com/group1/M00/12/22/L2pUHWR-7QqAa44SAAAndQaEDP8161.png')
          no-repeat;
        background-size: 100%;
        .vip_cont {
          display: flex;
          align-items: center;
          height: 100%;

          img {
            width: 15px;
          }

          .text {
            color: #fff;
            cursor: pointer;
            margin-left: 5px;
            background: rgba(255, 255, 255, 0.3);
            padding: 3px 5px;
            border-radius: 4px;
          }
        }
      }

      .inter_box {
        display: flex;
        box-sizing: border-box;
        padding: 20px;
        background-color: #fff;
        font-size: 12px;
        justify-content: space-between;
        span {
          margin-right: 5px;
          font-size: 16px;
          font-weight: bold;
        }
      }

      .nav_box {
        margin: 15px 0;
        display: flex;
        flex-wrap: wrap;
        background-color: #fff;
        font-size: 13px;

        .nav_item {
          width: 25%;
          padding: 15px 0;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          flex-direction: column;
          gap: 12px;
          img {
            width: 25px;
          }

          &:hover {
            background-color: #f2f5ff;
          }
        }
      }

      .logout {
        position: absolute;
        bottom: 25px;
        left: 50%;
        width: 100%;
        transform: translateX(-50%);
        text-align: center;

        .el-button {
          width: 60%;
        }
      }
    }
    .right {
      flex: 1;
      border-radius: 10px;
      height: 100%;
      background-color: #fff;
    }
  }
}
</style>
